import React from 'react'
import AboutSection from './AboutSection';
import VisionMission from './VisionMission';
import WhyUs from './WhyUs';

const AboutMain = () => {
  return (
    <>
        <AboutSection/>
        <VisionMission/>
        <WhyUs/>
    </>
  )
}
export default AboutMain;
